import "swiper/css/swiper.css";
import Vue from "vue";
import { Plugin } from "vue-fragment";
import VueNumber from "vue-number-animation";
import App from "./App.vue";
import router from "./router.js";
import i18n from "./i18n"; // 導入 i18n 配置
import "/public/css/main.css";

Vue.config.productionTip = false;
Vue.use(Plugin);
Vue.use(VueNumber);

new Vue({
    router,
    i18n, // 注入 i18n
    render: (h) => h(App),
}).$mount("#app");